import i18n from '@/plugins/i18n'
export default {
  '401': i18n.t('errorCode.401'),
  '403': i18n.t('errorCode.403'),
  '404': i18n.t('errorCode.404'),
  'default': i18n.t('errorCode.default')
}
